import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isProductAlertOverridesResult = objectOf({
  canvas_id: string,
  disabled_alert_ids: arrayOf(string),
});
